import React from 'react';
import ToggleSwitch from '../../Forms/Input/ToggleSwitch';
import { ProductFormValues } from '../../../types/product/ProductFormValues';

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductStockControlSection: React.FC<Props> = ({ form, onChange }) => (
  <div className="rounded-xl border border-stroke bg-gray-2 p-5 dark:border-strokedark dark:bg-meta-4/20">
    <ToggleSwitch
      label="Controlar stock estrictamente"
      name="stockControlEnabled"
      checked={form.stockControlEnabled}
      onChange={() => onChange('stockControlEnabled', !form.stockControlEnabled)}
    />
    <p className="mt-2 pr-16 text-xs leading-5 text-bodydark2">
      Este producto nunca podrá venderse en negativo, sin importar la
      configuración general de "Permitir ventas sin existencia". Útil para ir
      activando el control de inventario producto por producto.
    </p>
  </div>
);

export default ProductStockControlSection;
